export default 'fonts/e69b8ef5b87e4f55c87469e265827f3d.woff';